import { isEmpty } from 'es-toolkit/compat';
import { compressToEncodedURIComponent, decompressFromEncodedURIComponent } from 'lz-string';
import { QueryParamConfig } from 'use-query-params';

export const CompressedJsonParam: QueryParamConfig<any, any> = {
  encode: (value) => {
    if (value == null) return null;
    try {
      return compressToEncodedURIComponent(JSON.stringify(value));
    } catch (error) {
      console.error('Failed to compress JSON:', error);
      return null;
    }
  },
  decode: (value: string) => {
    if (isEmpty(value) || value === 'undefined') return null;
    let decompressed;
    try {
      decompressed = decompressFromEncodedURIComponent(value);
    } catch (error) {
      console.error('Failed to decompress JSON:', error, { value });
      return null;
    }
    let decompressedParseError;
    if (decompressed) {
      try {
        // Attempt to parse the decompressed value
        return JSON.parse(decompressed);
      } catch (error) {
        // If parsing fails, log the error but try to fall back to parsing the original value, in case it wasn't a compressed JSON
        decompressedParseError = error;
      }
    }
    try {
      return JSON.parse(value); // Fallback to parsing the original value if decompression returns null
    } catch (error) {
      if (decompressedParseError) {
        // If decompression was attempted but failed, log the decompression error
        console.error('Failed to parse decompressed JSON:', decompressedParseError, { value });
      }
      console.error('Failed to parse JSON without decompression:', error, { value });
      return null;
    }
  },
};
